import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { StudioBudgetModal } from "./StudioBudgetModal";

const WhatsAppIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.73 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.6h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.33-6.63-3.75-9.05a12.71 12.71 0 0 0-9.05-3.63zm0 23.36h-.004a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.02 1.05 1.07-3.92-.25-.4a10.56 10.56 0 0 1-1.62-5.63c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.5 1.11 7.51 3.12a10.55 10.55 0 0 1 3.11 7.52c0 5.86-4.77 10.63-10.64 10.63zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.89-1.78-2.21-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.55-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.54-.71-.55l-.61-.01c-.21 0-.55.08-.84.4-.29.32-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.23 3.41 5.4 4.78.75.32 1.34.52 1.8.66.76.24 1.44.21 1.98.13.6-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

export const WhatsAppPopup = () => {
  const [showCard, setShowCard] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [budgetOpen, setBudgetOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowCard(true), 5000);
    return () => clearTimeout(t);
  }, []);

  const openChat = () => {
    setShowCard(false);
    setDismissed(true);
    setBudgetOpen(true);
  };

  const closeCard = () => {
    setShowCard(false);
    setDismissed(true);
  };

  return (
    <>
    <div className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-[130] flex flex-col items-start gap-3">
      {showCard && (
        <div
          className="w-[300px] max-w-[calc(100vw-2rem)] rounded-2xl bg-[#0F0F0F] text-white shadow-2xl border border-[#D4AF37]/30 overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-300"
          data-testid="whatsapp-popup-card"
        >
          <div className="relative p-5">
            <button
              onClick={closeCard}
              aria-label="Close"
              className="absolute top-3 right-3 w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white/80 transition-colors"
              data-testid="whatsapp-popup-close"
            >
              <X size={15} />
            </button>

            <div className="flex items-center gap-2.5 pr-6">
              <span className="w-9 h-9 rounded-full bg-[#25D366] text-white flex items-center justify-center shrink-0">
                <WhatsAppIcon size={20} />
              </span>
              <p className="font-display font-bold text-[15px] leading-snug text-[#D4AF37]">
                Looking for Website or App Assistance?
              </p>
            </div>

            <p className="text-[13px] text-white/70 mt-3 leading-relaxed">
              Need help? Chat with LaunchBS about your website or app project.
            </p>

            <button
              onClick={openChat}
              className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full py-2.5 text-sm font-bold transition-colors"
              data-testid="whatsapp-popup-chat-btn"
            >
              <WhatsAppIcon size={18} /> Chat on WhatsApp
            </button>
          </div>
        </div>
      )}

      {dismissed && (
        <button
          onClick={openChat}
          aria-label="Chat on WhatsApp"
          className="w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white shadow-xl ring-2 ring-[#D4AF37]/40 flex items-center justify-center transition-all hover:scale-105"
          data-testid="whatsapp-float-icon"
        >
          <WhatsAppIcon size={28} />
        </button>
      )}
    </div>
    <StudioBudgetModal open={budgetOpen} onClose={() => setBudgetOpen(false)} projectRef="" />
    </>
  );
};
